/*
 * AppReducer
 *
 * The reducer takes care of our data. Using actions, we can change our
 * application state.
 * To add a new action, add it to the switch statement in the reducer function
 *
 * Example:
 * case YOUR_ACTION_CONSTANT:
 *   return state.set('yourStateVariable', true);
 */

import {
  GET_REFRESHED_TOKEN_SUCCESS,
  GET_PROFILE_SUCCESS,
  INVALID_ACCESS,
  LOG_OUT,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  INIT_PLUGINS_SUCCESS,
  CHECK_PLUGINS_SUCCESS,
  MENU_TOGGLE,
  LOADING,
  API_INFO_SUCCESS,
  DELETE_HELP,
} from './actions';

import {
  API_CREATE_ERROR,
  API_READ_SUCCESS,
  API_READ_ERROR,
  API_UPDATE_SUCCESS,
  API_UPDATE_ERROR,
  API_DELETE_SUCCESS,
  API_DELETE_ERROR,
  WIDGET_REGISTER,
  CONFIG_SUCCESS,
  MENU_EDIT,
  LOAD_HELP_SUCCESS,
  DELETE_STORE_DATA
} from 'vx-commons/lib/actions';

import {
  emptyMenu
} from '../../utils/initialstate';

import {
  Map as map,
  List as list,
} from 'immutable';

function sortMenu(a, b) {
  if (a.index === b.index) {
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
  } else {
    if (a.index < b.index) return -1;
    if (a.index > b.index) return 1;
    return 0;
  }
}

function appReducer(state, action) {
  let menu;

  switch (action.type) {
    case MENU_EDIT:      
      menu = state.get('menu').toJS();
      // rigenerate menu
      if (action.menu.child && action.menu.child.length > 0) {
        const idx = menu.findIndex((item) => {
          return item.id === action.menu.id;
        });
        if (idx === -1) {
          action.menu.child.sort(sortMenu);
          menu.push(action.menu);
        } else {
          menu[idx].child.forEach((element, indice) => {
            action.menu.child.forEach(newMenu => {
              if (newMenu.id === element.id) {
                menu[idx].child.splice(indice, 1);
              }
            });
          });
          menu[idx].child = menu[idx].child.concat(action.menu.child);
          menu[idx].child.sort(sortMenu);
        }
      }
      // reorder items
      menu.sort(sortMenu);

      // save menu
      sessionStorage.setItem('menu', JSON.stringify(menu));
      return state
        .set('menu', list(menu));
    case MENU_TOGGLE:
      menu = state.get('menu').toJS();
      // rigenerate menu
      menu.forEach((element, idx) => {
        element.expand = false;
      });

      menu = menu.map((item) => {
        if (action.menu && item.id === action.menu.id) {
          item.expand = true;
        } else {
          item.expand = false;
        }
        return item;
      });
      // save menu
      sessionStorage.setItem('menu', JSON.stringify(menu));
      const _menu = list(menu);

      return state.set('menu', _menu);
    case INVALID_ACCESS:
      return state
        .set('loginRequired', true);
    case LOG_OUT:
      sessionStorage.removeItem('userData');
      sessionStorage.removeItem('menu');
      return state
        .set('loginRequired', true)
        .set('userData', {})
        .set('menu', list(emptyMenu));
    case LOGIN_SUCCESS:
      sessionStorage.setItem('userData', JSON.stringify(action.profile));
      return state
        .set('loginRequired', false)
        .set('error', false)
        .set('userData', action.profile);
    case LOGIN_FAILED:
      sessionStorage.setItem('error', JSON.stringify(action.error));
      return state
        .set('error', action.error);
    case LOADING:
      sessionStorage.setItem('loading', JSON.stringify(action.value));
      return state
        .set('loading', action.value);
    ///
    case GET_REFRESHED_TOKEN_SUCCESS:
      sessionStorage.setItem('userData', JSON.stringify(
        {
          ...state.get('userData'),
          api_key: action.token.api_key
        }
      ));
      return state.update("userData", () => (
        {...state.get('userData'), api_key: action.token.api_key})
      );
    ///
    case GET_PROFILE_SUCCESS:
      sessionStorage.setItem('userData', JSON.stringify(action.payload));
      return state
        .set('loginRequired', false)
        .set('userData', action.payload);
    case API_INFO_SUCCESS:
      sessionStorage.setItem('apiInfo', JSON.stringify(action.info));
      return state
        .set('apiInfo', action.info);
    case API_UPDATE_SUCCESS:
      return state.update('data', map(),
        msgs => msgs.set(action.fromAction.dataId, {
          data: [action.data.data]
        }));
    case API_DELETE_SUCCESS:
      return state.update('data', map(),
        msgs => msgs.set(action.fromAction.dataId, {
          data: [],
          status: 404
        }));
    case API_READ_SUCCESS:
      return state.update('data', map(),
        msgs => msgs.set(action.fromAction.dataId, action.data));
    case API_CREATE_ERROR:
    case API_READ_ERROR:
    case API_UPDATE_ERROR:
    case API_DELETE_ERROR:
      return state.update('data', map(),
        msgs => msgs.set(action.fromAction.dataId, action.error));
    case CHECK_PLUGINS_SUCCESS:
      return state
        .update('fetching', list(),
          fetch => fetch.filter(item => item !== 'plugins'));
    case INIT_PLUGINS_SUCCESS:
      sessionStorage.setItem('plugins', JSON.stringify(action.plugins));
      return state
        .set('plugins', list(action.plugins))
        .update('fetching', list(),
          fetch => fetch.filter(item => item !== 'plugins'));
    case WIDGET_REGISTER:
      const widgets = state.get('widgets').toJS();

      if (widgets.find((item) => item.id === action.widget.id) === undefined) {
        widgets.push(action.widget);
      }

      sessionStorage.setItem('widgets', JSON.stringify(widgets));
      return state
        .set('widgets', list(widgets));
    case CONFIG_SUCCESS:
      sessionStorage.setItem('config', JSON.stringify(action.config));
      return state.set('config', action.config);
    case LOAD_HELP_SUCCESS:
      return state.set(action.helptype, action.help);
    case DELETE_HELP:
      return state.set('helpwidget', action.payload);
    case DELETE_STORE_DATA:
      return state.update('data', map(), msgs => msgs.delete(action.dataId));
    default:
      return state;
      
  }
}

export default appReducer;


// WEBPACK FOOTER //
// ./src/containers/App/reducer.js